import { Icon } from "../ui";

// §9.17/D139 — Transport: Play/Pause, Frame-Schritt (←/→), Frame-Zähler. Tastatur (Space/←/→)
// liegt in StudioShell (mit isTextEntryTarget-Guard); hier nur die Buttons.

export function TransportBar({
  playing,
  index,
  total,
  fps,
  onTogglePlay,
  onStep,
}: {
  playing: boolean;
  index: number;
  total: number;
  fps: number;
  onTogglePlay: () => void;
  onStep: (delta: number) => void;
}) {
  return (
    <div className="flex items-center gap-2 px-3 py-2 text-sm text-muted">
      <button
        type="button"
        onClick={() => onStep(-1)}
        className="grid h-8 w-8 place-items-center rounded-lg hover:bg-surface-2 hover:text-text"
        title="Voriger Frame (←)"
        disabled={total === 0}
      >
        <span style={{ transform: "scaleX(-1)" }} className="inline-flex">
          <Icon name="chevron-right" size={18} />
        </span>
      </button>
      <button
        type="button"
        onClick={onTogglePlay}
        className="grid h-9 w-9 place-items-center rounded-lg bg-accent/15 text-accent hover:bg-accent/25"
        title={playing ? "Pause (Leertaste)" : "Abspielen (Leertaste)"}
        disabled={total === 0}
      >
        <Icon name={playing ? "pause" : "play"} size={18} />
      </button>
      <button
        type="button"
        onClick={() => onStep(1)}
        className="grid h-8 w-8 place-items-center rounded-lg hover:bg-surface-2 hover:text-text"
        title="Nächster Frame (→)"
        disabled={total === 0}
      >
        <Icon name="chevron-right" size={18} />
      </button>
      <span className="ml-2 tabular-nums">
        Frame {total === 0 ? 0 : index + 1} / {total}
      </span>
      <span className="ml-auto tabular-nums text-xs">{fps} fps</span>
    </div>
  );
}
